export default __webpack_public_path__ + "static/media/message_alerte.afbd0fcb.mp3";